import httpService from "core/services/httpService";

import API_URL from "core/constants/api/apiUrl";

const projectService = {
    getAll(data, signal){
        return httpService.get({
            url: API_URL.GET_PROJECTS,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return {
                data: value.item2,
                total: value.item1
            };
        })
    },
    getPostbackSettings(signal){
        return httpService.get({
            url: API_URL.GET_POSTBACK_SETTINGS,
            signal
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    savePostbackSettings(data, signal){
        return httpService.post({
            url: API_URL.SAVE_POSTBACK_SETTINGS,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message};
        })
    },

    getProjectConfiguration(signal){
        return httpService.get({
            url: API_URL.PROJECT_CONFIGURATION,
            signal
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    saveProjectConfiguration(data, signal){
        return httpService.post({
            url: API_URL.PROJECT_SAVE_CONFIGURATION,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message};
        })
    },

    getProjectAffiliateRegistrationConfiguration(signal){
        return httpService.get({
            url: API_URL.GET_PROJECT_AFFILIATE_REGISTRATION_CONFIGURATION,
            signal
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    saveProjectAffiliateRegistrationConfiguration(data, signal){
        return httpService.post({
            url: API_URL.SAVE_PROJECT_AFFILIATE_REGISTRATION_CONFIGURATION,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message};
        })
    },

    createProject(data, signal){
        return httpService.post({
            url: API_URL.CREATE_PROJECT,
            signal,
            requestBody: data
        }).then(({ data: { value, message }, data }) => {
            return { value, message, resultCode: data.resultCode };
        })
    },
}

export default projectService